import Grid from "@mui/material/Grid2";
import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Input,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Close } from "@mui/icons-material";
import "./payment.scss";
import { AppDispatch } from "src/redux/store";
import {
  CheckoutPayment,
  UpdateSubscription,
} from "src/redux/features/plan-billing/plan-billing-slice";
import PaymentSystemService from "./../../service/paymentSystem.service";
import { Alert, Snackbar } from "@mui/material";
import { current } from "node_modules/@reduxjs/toolkit/dist";

interface SubscriptionFinalCardProps {
  product: any; //plan product detail
  mailProduct: any; //mailbox addon product detail
  textProducts: any;
  smsPriceId: string;
  scheduleProduct: any;
  mailAddCheck: boolean;
  textAddCheck: boolean;
  scheduleAddCheck: boolean;
  addOnPage: boolean;
  selectedPlan: any; //target plan, may not be same as current plan
  adminSeats: number;
  mailboxSeats: number;
  showCouponField: boolean;
  isUpdate: boolean;
}

const SubscriptionFinalCard: React.FC<SubscriptionFinalCardProps> = ({
  product,  //selected main plan product
  mailProduct, //selected mailbox addon
  textProducts,
  smsPriceId, //selected sms tier index
  scheduleProduct,
  mailAddCheck,
  textAddCheck,
  scheduleAddCheck,
  addOnPage,
  selectedPlan,
  adminSeats,
  mailboxSeats,
  showCouponField,
  isUpdate,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const [seatCount, setSeatCount] = useState(0);
  const [coupon, setCoupon] = useState("");
  const [textId, setTextId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponDialogOpen, setCouponDialogOpen] = useState(false);
  const [couponDialogMessage, setCouponDialogMessage] = useState("");
  // const [discountAmount, setDiscountAmount] = useState(0);
  const [isOpen, setOpen] = useState(false);
  
  const [mailboxSeatCount, setMailboxSeatCount] = useState(
    mailboxSeats || 1
  );
  const [mailboxCost, setMailboxCost] = useState(0);
  const [smsCost, setSmsCost] = useState(0);
  const [scheduleCost, setScheduleCost] = useState(0);
  const [adminSeatsCost, setAdminSeatsCost] = useState(0);
  const textOptions = [
    { id: 0, label: "500 texts" },
    { id: 1, label: "1500 texts" },
    { id: 2, label: "5000 texts" },
    { id: 3, label: "10000 texts" },
  ];

  // const adminSeatsProducts = useSelector(
  //   (state: RootState) => state.planBillingSlice.addons.adminSeatsProducts
  // );

  const [total, setTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0); //total without discount
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  
  const [existingDiscounts, setExistingDiscounts] = useState<Array<{
    code: string;
    type: string;
    value: number;
    amount: number;
    text: string;
  }>>([]);

  // const currentPlan = useSelector(
  //   (state: RootState) => state.planBillingSlice.currentPlan
  // );
  const [discounts, setDiscounts] = useState(selectedPlan?.discounts);

  const costsUpdated = useRef(false);

  const handleClose = () => {
    setTimeout(() => setOpen(false), 6000);
  };

  const handleApplyCoupon = async () => {
    setCouponApplied(false);
    // setDiscountAmount(0);
    setLoading(true);

    if (!coupon.trim()) {
      setCouponDialogMessage("Please enter a valid coupon code.");
      setCouponDialogOpen(true);
      return;
    }

    if (existingDiscounts.some(discount => discount.code === coupon)) {
      setCouponDialogMessage("Coupon code already applied.");
      setCouponDialogOpen(true);
      return;
    }

    try {

      const discount = await computeDiscountAmount(coupon);
      if (discount === 0) {
        setCouponDialogMessage("Please enter a valid coupon code.");
        setCouponDialogOpen(true);
        return;
      }
    
      setExistingDiscounts([
        ...existingDiscounts,
        {
          code: coupon,
          type: "",
          value: discount,
          amount: discount,
          text: `${coupon} (-$${discount})`
        }
      ]);
      
      setCouponApplied(true);
      // setDiscountAmount(data.discount);
      setOpen(true);
      setLoading(false);
      setCoupon("");
      
    } catch (err: any) {
      console.error("Coupon validation error:", err);
      const msg =
        err.response?.data?.error || "Server error. Please try again.";
      setCouponDialogMessage(msg);
      setCouponDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const handleMailBoxCountChange = (event: any) => {
    const num = parseInt(event.target.value, 10);
    if (!isNaN(num)) {
      setMailboxSeatCount(num);
    }
  };

  const handleTextChange = (event: any) => {
    setTextId(event.target.value);
  };

  const handleCouponChange = (event: any) => {
    const value = event.target.value;
    setCoupon(value);
    if (!value.trim()) {
      // setDiscountAmount(0);
      setCouponApplied(false);
    }
  };
  const buildAddons = () => {
    const addons: any = {};
    if (mailAddCheck && mailboxSeatCount > 0) {
      addons.mailbox = {
        priceId: mailProduct?.priceId,
        quantity: mailboxSeatCount,
      };
    }
    if (textAddCheck) {
      addons.sms = {
        priceId: textProducts[textId]?.priceId,
      };
    }
    if (scheduleAddCheck) {
      addons.scheduling = {
        priceId: scheduleProduct.priceId,
      };
    }
    // console.log("[buildAddons] addons:", addons);
    return addons;
  };

  const handleConfirmedCheckout = async () => {
    setConfirmOpen(false);
    setLoading(true);
    try {
      const addons = buildAddons();
      if (isUpdate && selectedPlan?.currentSubscriptionId) {
        // console.log("seatCount, adminSeats", seatCount, adminSeats);
        await dispatch(
          UpdateSubscription({
            productId: selectedPlan.planDetail.productId,
            updateMode: "update-plan", //must match with backend!!
            adminSeats: seatCount,
            addons: addons,
            promoCodes: existingDiscounts.map(discount => discount.code)
          })
        );
        setCoupon("");
      } else {
        console.log("begin checkout");
        console.log("seatCount, addons:", seatCount, addons);
        await dispatch(
          CheckoutPayment({
            productId: selectedPlan?.planDetail?.productId,//product.productId,
            adminSeats: seatCount,
            addons
          })
        );
      }
      navigate("/my-plan");
    } catch (err) {
      console.error("Checkout error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckoutClick = () => {
    // Check if there's an unapplied coupon
    if (coupon.trim()?.length > 0) {
      setCouponDialogMessage("Please click 'Apply' to apply your coupon code first.");
      setCouponDialogOpen(true);
      return;
    }
    setConfirmOpen(true);
  };

  // Wait for selectedPlan to be populated
  useEffect(() => {
    if (adminSeats) {
      setSeatCount(adminSeats);
    } else {
      setSeatCount(selectedPlan?.adminSeats);
    }
  }, [selectedPlan?.adminSeats, adminSeats]);

  useEffect(() => {
    const index = textProducts.findIndex(
      (textAddon: { priceId: string }) => textAddon.priceId === smsPriceId
    );
    if (index !== -1) {
      setTextId(index);
    }
  }, [smsPriceId, textProducts]);

  // Effect for setting costs
  useEffect(() => {
    if (!mailProduct?.price) {
      costsUpdated.current = false;
      return;
    }

    costsUpdated.current = false; // Reset the flag before updating costs
    
    if (mailAddCheck) {
      const newMailboxCost = mailboxSeatCount * (mailProduct?.price);
      setMailboxCost(newMailboxCost);
    } else {
      setMailboxCost(0);
      // Remove mailbox discounts when mailbox is unchecked
      setExistingDiscounts(prevDiscounts => 
        prevDiscounts.filter(discount => !discount.code.toLowerCase().includes('mailbox'))
      );
    }
  }, [mailAddCheck, mailboxSeatCount, mailProduct]);

  useEffect(() => {
    if (!textProducts[textId]?.price) {
      costsUpdated.current = false;
      return;
    }
    if (textAddCheck) {
      setSmsCost(textProducts[textId]?.price);
    } else {
      setSmsCost(0);
      // Remove sms discounts when sms is unchecked
      setExistingDiscounts(prevDiscounts => 
        prevDiscounts.filter(discount => !discount.code.toLowerCase().includes('sms'))
      );
    }
  }, [textAddCheck, textProducts, textId]);

  useEffect(() => {
    if (!scheduleProduct?.price) {
      costsUpdated.current = false;
      return;
    }
    if (scheduleAddCheck) {
      setScheduleCost(scheduleProduct.price);
    } else {
      setScheduleCost(0);
      // Remove scheduling discounts when scheduling is unchecked
      setExistingDiscounts(prevDiscounts => 
        prevDiscounts.filter(discount => !discount.code.toLowerCase().includes('scheduling'))
      );
    }
  }, [scheduleAddCheck, scheduleProduct]);

  // Calculate admin seats cost
  useEffect(() => {
    if (seatCount <= selectedPlan?.planDetail?.adminCovered) {
      setAdminSeatsCost(0);
    } else {
      setAdminSeatsCost((seatCount - selectedPlan?.planDetail?.adminCovered) * (product?.adminSeatPrice || 0));
    }
    
    // Only set costsUpdated to true after all costs are set
    const allCostsLoaded = 
      (mailAddCheck ? mailboxCost !== undefined : true) &&
      (textAddCheck ? smsCost !== undefined : true) &&
      (scheduleAddCheck ? scheduleCost !== undefined : true);
      
    costsUpdated.current = allCostsLoaded;
  }, [seatCount, selectedPlan?.planDetail?.adminCovered, product?.adminSeatPrice, 
      mailAddCheck, textAddCheck, scheduleAddCheck, mailboxCost, smsCost, scheduleCost]);

  // Separate useEffect for loading discounts after costs are set
  useEffect(() => {
    if (!costsUpdated.current) return; // Skip if costs haven't been updated yet

    const loadExistingDiscounts = async () => {
      if (!selectedPlan?.discounts?.length) {
        setExistingDiscounts([]);
        return;
      }

      const discounts = await Promise.all(
        selectedPlan.discounts.map(async (discount: any) => {
          const amount = await computeDiscountAmount(
            discount.promotionCode);
          return {
            code: discount.promotionCode || discount.couponName,
            type: discount.couponType,
            value: discount.couponValue,
            amount: amount,
            text: `${discount.promotionCode || discount.couponName} (${
              discount.couponType === "percentage"
                ? `${discount.couponValue}% off`
                : discount.couponType === "fixed_amount"
                ? `-$${discount.couponValue / 100}`
                : ""
            })`
          };
        })
      );
      // console.log("[loadExistingDiscounts] discounts:", selectedPlan.discounts, discounts);
      setExistingDiscounts([...discounts]);
    };

    loadExistingDiscounts();
  }, [
    selectedPlan?.discounts,
    selectedPlan?.planDetail?.productId,
    mailboxCost, // Include mailboxCost to handle changes
    smsCost,
    scheduleCost
  ]);

  // Recalculate subTotal and total
  useEffect(() => {
    const calculateSubTotal = () => {
      const basePrice = (!showCouponField && isUpdate) ? 0 : selectedPlan?.planDetail?.price;
      const subTotal = basePrice + mailboxCost + smsCost + scheduleCost + adminSeatsCost;
      return subTotal;
    };

    const newSubTotal = calculateSubTotal();
    setSubTotal(newSubTotal);

    // Calculate total discount amount from all existing discounts
    const totalDiscount = existingDiscounts.reduce((total, discount) => {
      return total + (discount.amount || 0);
    }, 0);
    setTotal(newSubTotal - totalDiscount);

  }, [
    mailboxCost,
    smsCost,
    scheduleCost,
    selectedPlan?.planDetail?.price,
    showCouponField,
    isUpdate,
    existingDiscounts
  ]);


  // Compute discount amount based on addon option
  const computeDiscountAmount = async (couponCode: string) => {
    // Wait for costs to be fully loaded
    if (!costsUpdated.current) {
      console.log("Costs not yet loaded, waiting...");
      return 0;
    }

    if (!couponCode?.trim()) return 0;

    let discountBase = selectedPlan?.planDetail?.price || 0; //use plan base
    if (couponCode.toLowerCase().includes('mailbox')) {
      discountBase = mailboxCost;
    } else if (couponCode.toLowerCase().includes('sms')) {
      discountBase = smsCost; 
    } else if (couponCode.toLowerCase().includes('scheduling')) {
      discountBase = scheduleCost;
    }

    // Validate that we have a proper discountBase for the coupon type
    if ((couponCode.toLowerCase().includes('mailbox') && mailboxCost === 0) ||
        (couponCode.toLowerCase().includes('sms') && smsCost === 0) ||
        (couponCode.toLowerCase().includes('scheduling') && scheduleCost === 0)) {
      console.log("Warning: Addon cost is 0 for coupon", couponCode);
      return 0;
    }

    const data = await PaymentSystemService.validateCoupon(
      selectedPlan?.planDetail?.productId, //main plan productid
      discountBase,
      couponCode
    );

    return data.discount;
  };

  // console.log("seatCount, selectedPlan:", seatCount, selectedPlan);
  // console.log("product:", product);
  // console.log("Final-Card Selected Plan:", selectedPlan);
  // console.log("existingDiscounts", existingDiscounts);
  // console.log("isUpdate && showCouponField:", isUpdate, showCouponField);
  // console.log("mailboxCost", mailboxCost);

  return (
    <>
      <Grid size={{ xs: 6, md: 6 }} mt={6}>
        <Typography variant="h5" fontWeight={"550"} marginBottom={"20px"}>
          {isUpdate && selectedPlan?.currentSubscriptionId 
            ? "Change Plan"
            : "Checkout Plan"}
        </Typography>
        
        <div className="planMainCard">
            <Grid display={"flex"} flexDirection={"column"} gap={"20px"}>
              
              {/* Plan */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box display="flex" alignItems="center" gap="20px">
                  <Typography fontSize={"18px"} fontWeight={600}>
                    {selectedPlan?.planDetail?.title}
                  </Typography>

                  {/* change plan, buggy */}
                  {/* <Button 
                    sx={{ fontWeight: 600 }} 
                    onClick={() => {
                      const selectedAddons: any = {};
                      
                      if (selectedPlan?.addons?.mailbox) {
                        selectedAddons.mailbox = {
                          priceId: selectedPlan.addons.mailbox.priceId,
                          quantity: selectedPlan.addons.mailbox.quantity,
                        };
                      }
                      
                      if (selectedPlan?.addons?.sms) {
                        selectedAddons.sms = {
                          priceId: selectedPlan.addons.sms.priceId,
                        };
                      }
                      
                      if (selectedPlan?.addons?.scheduling) {
                        selectedAddons.scheduling = {
                          priceId: selectedPlan.addons.scheduling.priceId,
                        };
                      }

                      navigate("/view-plan", {
                        state: {
                          selectedPlan: selectedPlan.planDetail,
                          addOnPage: false,
                          selectedAddons,
                          adminSeats: seatCount,
                          mailBoxSeats: mailboxSeatCount,
                          mailAddCheck: !!selectedAddons.mailbox?.priceId,
                          textAddCheck: !!selectedAddons.sms?.priceId,
                          scheduleAddCheck: !!selectedAddons.scheduling?.priceId,
                        },
                      });
                    }}
                  >
                    change
                  </Button> */}
                </Box>
                <Typography fontSize={"23px"} color="#096dd9" fontWeight={600}>
                  ${selectedPlan?.planDetail?.price?.toLocaleString()} / mo
                </Typography>
              </Box>

              {/* <Typography fontSize={"18px"}>ADD-ONS</Typography> */}

              {/* Admin Seats */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontSize={"18px"} fontWeight={600}>
                  Total Admin Seats
                </Typography>
                <Box display="flex" alignItems="center" gap="20px">
                  {/* <Typography fontSize="18px">Seats</Typography> */}
                  <Input
                    sx={{ width: "40px" }}
                    inputProps={{
                      sx: { textAlign: "center" },
                      min: selectedPlan?.planDetail?.adminCovered || 1,
                      type: "number",
                    }}
                    value={seatCount}
                    onChange={(e) => {
                      const newCount = parseInt(e.target.value);
                      const minSeats = selectedPlan?.planDetail?.adminCovered || 1;
                      if (!isNaN(newCount) && newCount >= minSeats) {
                        setSeatCount(newCount);
                      }
                    }}
                  />
                  <Typography fontSize={"18px"} color="gray">
                    ({selectedPlan?.planDetail?.adminCovered} covered)
                  </Typography>
                
                  <Typography fontSize={"23px"} color="#096dd9" fontWeight={600}>
                    {adminSeatsCost === 0 
                      ? "$0 / mo"
                      : `$${adminSeatsCost} / mo`}
                  </Typography>
                </Box>
              </Box>

              {/* Mailbox Add-On */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontSize={"18px"} fontWeight={600}>
                  Mailbox Integration
                </Typography>
                <Box display="flex" alignItems="center" gap="20px">
                  {mailAddCheck && (
                    <>
                      <Typography fontSize="18px">
                        {" "} Mailboxes 
                      </Typography>
                      <Input
                        sx={{ width: "40px" }}
                        inputProps={{
                          sx: { textAlign: "center" },
                          min: 1,
                          type: "number",
                        }}
                        value={mailboxSeatCount}
                        onChange={handleMailBoxCountChange}
                      />
                    </>
                  )}
                  <Typography fontSize={"23px"} color="#096dd9" fontWeight={600}>
                    ${mailAddCheck ? mailboxCost : 0}{" "} / mo
                  </Typography>
                </Box>
              </Box>

              {/* SMS Add-On */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontSize={"18px"} fontWeight={600}>
                  SMS Integration
                </Typography>
                <Box display="flex" alignItems="center" gap="10px">
                  {textAddCheck && (
                    <Select
                      labelId="dropdown-label"
                      value={textId}
                      onChange={handleTextChange}
                    >
                      {textOptions.map((opt) => (
                        <MenuItem key={opt.id} value={opt.id}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  <Typography fontSize={"23px"} color="#096dd9" fontWeight={600}>
                    ${textAddCheck ? smsCost : 0} / mo
                  </Typography>
                </Box>
              </Box>

              {/* Schedule Add-On */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontSize={"18px"} fontWeight={600}>
                  Scheduling
                </Typography>
                <Typography fontSize={"23px"} color="#096dd9" fontWeight={600}>
                  ${scheduleAddCheck ? scheduleCost : 0}{" "}/ mo
                </Typography>
              </Box>

              <Divider sx={{ borderBottomWidth: 2 }} />
              {/* Existing Promotions */}
              {existingDiscounts?.map((discount, index) => (
                <Box
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{mb: 1}}
                >
                  <Typography fontSize={"16px"}>
                  {discount.code}
                  </Typography>
                  <Typography fontSize={"23px"} color="#096dd9" fontWeight={600}>
                    {`-$${discount.amount} / mo`}
                  </Typography>
                </Box>
              ))}

              {/* New Coupon */}
              {/* Only for update flow */}
              {(isUpdate && showCouponField && selectedPlan?.currentSubscriptionId) && (
                <>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography fontSize={"18px"} fontWeight={600}>
                    Coupon
                  </Typography>
                  <Box display="flex" alignItems="center" gap="10px">
                    <Input
                      sx={{ width: "150px" }}
                      inputProps={{
                        sx: { textAlign: "center" },
                        type: "text",
                        maxLength: 20,
                      }}
                      value={coupon}
                      onChange={handleCouponChange}
                    />
                    <Button
                      sx={{ fontWeight: 600 }}
                      onClick={handleApplyCoupon}
                      disabled={loading || !coupon.trim()}
                    >
                      Apply
                    </Button>
                  </Box>
                </Box>
                <Divider sx={{ borderBottomWidth: 2, my: 2 }} />
                </>
              )}
              

              {/* Total */}
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontSize={"18px"} fontWeight={600}>
                  Total
                </Typography>
                <Typography fontSize={"23px"} color="#096dd9" fontWeight={600}>
                  ${total} / mo
                </Typography>
              </Box>

              <Box sx={{ textAlign: "end" }}>
                <Button
                  sx={{
                    backgroundColor: "#096dd9",
                    padding: "8px 24px",
                    color: "white",
                    borderRadius: "4px",
                    textAlign: "center",
                  }}
                  onClick={handleCheckoutClick}
                  disabled={loading}
                >
                  {loading
                    ? "Processing..."
                    : "Submit"}
                </Button>
              </Box>
            </Grid>
        </div>
          
      </Grid>

      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        className="smallModel upgradeModal"
      >
        <div>
          <Grid>
            <Box className="largeModel__head">
              <Typography variant="h5" className="largeModel__title">
                {isUpdate && selectedPlan?.currentSubscriptionId 
                ? "Confirm Update Subscription" : "Confirm Checkout"}
              </Typography>
              <Button
                className="largeModel__closeBtn"
                onClick={() => setConfirmOpen(false)}
              >
                <Close />
              </Button>
            </Box>
          </Grid>

          <DialogContent>
            <Typography>
              Total subscription: <strong>${total} / mo</strong>
            </Typography>
            {/* {isUpdate && (
              <Typography color="error" mt={2}>
                This update will be auto-charged to your saved payment method.
              </Typography>
            )} */}
          </DialogContent>

          <DialogActions>
            <Button
              className="border-button"
              variant="contained"
              onClick={() => setConfirmOpen(false)}
            >
              Cancel
            </Button>
            <Button
              className="button"
              variant="contained"
              onClick={handleConfirmedCheckout}
            >
              Confirm
            </Button>
          </DialogActions>
        </div>
      </Dialog>

      <Dialog
        open={couponDialogOpen}
        onClose={() => setCouponDialogOpen(false)}
        className="smallModel upgradeModal"
      >
        <div>
          <Grid>
            <Box className="largeModel__head">
              <Typography variant="h5" className="largeModel__title">
                Invalid Coupon
              </Typography>
              <Button
                className="largeModel__closeBtn"
                onClick={() => setCouponDialogOpen(false)}
              >
                <Close />
              </Button>
            </Box>
          </Grid>
          <DialogContent>
            <Typography>{couponDialogMessage}</Typography>
          </DialogContent>
        </div>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isOpen}
        autoHideDuration={0}
        onClose={handleClose}
      >
        <Alert severity={"success"} sx={{ width: "100%" }}>
          Coupon Applied Successfully.
        </Alert>
      </Snackbar>
    </>
  );
};

export default SubscriptionFinalCard;
